import i18n from '../i18n';

export default function localeRoute(url: string) {
  const lng = i18n.language;
  if (lng === 'ja') return url;
  return `/en${url}`;
}
